module.exports = __webpack_public_path__ + "img/Spain.a8ab6fc4.png";